import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/debouwapp.webp';
import screenshot_target from '../../../images/letterfunnel/paulfrankenhuizen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Paul Frankenhuizen"
      firstname="Paul"
      companyname="De BouwApp"
      competition="Omniom en Cobee"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/paulfrankenhuizen.js